import axios from '@/axios'

// initial state
const state = {
  channels: [],
}

const getters = {
  channels: (state) => state.channels
}

// actions
const actions = {
  async getChannels({ commit }) {
    const { data } = await axios.get('channels/new')
    commit('setChannels', data.data)
  },

  async findChannel({state, dispatch}, id) {
    if (state.channels.length === 0) {
      await dispatch('getChannels')
    }
    return state.channels.find(p => p.id === id)
  },
}

// mutations
const mutations = {
  setChannels (state, content) {
    state.channels = content
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
